import React, { useMemo } from 'react';
import * as yup from 'yup';
import { SchemaOf } from 'yup';
import { DSection, RhFormWrapper, RhSingleAutocomplete } from '../../../../../dum';
import {
    useOrderSaleOrderSaleStatusInputQuery,
    useUpdateOrderSaleStatusMutation,
} from '../../../../../../services';
import {
    FIELD_LABELS,
    shortLabel,
    transformToNumber,
} from '../../../../../../helpers';

interface IOrderSaleStatusChange {
    order_sale_status_id?: number | null;
}

interface IOrderSaleStatusChangeFormProps {
    orderSaleId: number;
    currentStatusId?: number | null;
    onSuccess: () => void;
}

// Status-only form, separate from the sale upsert. The upsert no longer accepts
// a status, so this admin-only mutation is the only way to move a sale between
// statuses.
export function OrderSaleStatusChangeForm({
    orderSaleId,
    currentStatusId,
    onSuccess,
}: IOrderSaleStatusChangeFormProps) {
    const { data } = useOrderSaleOrderSaleStatusInputQuery();
    const [mutation, { loading }] = useUpdateOrderSaleStatusMutation();

    const orderSaleStatuses = data?.getOrderSaleStatuses || [];

    const initialValues = useMemo<IOrderSaleStatusChange>(() => {
        return {
            order_sale_status_id: currentStatusId || 1,
        };
    }, [currentStatusId]);

    const validationSchema: SchemaOf<IOrderSaleStatusChange> = yup.object({
        order_sale_status_id: yup
            .number()
            .transform(transformToNumber)
            .nullable()
            .required(`'Status' es obligatorio`),
    });

    return (
        <RhFormWrapper
            validationSchema={validationSchema}
            initialValues={initialValues}
            disabled={loading}
            onSubmit={async (formData) => {
                try {
                    await mutation({
                        variables: {
                            OrderSaleId: orderSaleId,
                            OrderSaleStatusId: formData.order_sale_status_id!,
                        },
                    });
                    onSuccess();
                } catch (e) {
                    console.error(e);
                }
            }}
        >
            <DSection alwaysOpen>
                <RhSingleAutocomplete
                    itemText={'name'}
                    itemValue={'id'}
                    name={'order_sale_status_id'}
                    label={shortLabel(FIELD_LABELS.order_sale_status_id)}
                    options={orderSaleStatuses}
                />
            </DSection>
        </RhFormWrapper>
    );
}
